var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "atlas-tra" } },
    [
      _vm.datetime_list.length !== 0
        ? _c("v-select", {
            staticClass: "date_time__select__box",
            attrs: {
              items: _vm.datetime_list,
              id: "atlas_table_datetime_select",
              "item-text": "text",
              "item-value": "value",
              label: "" + (this.current_data.label || "選擇時間區間"),
              "hide-details": ""
            },
            model: {
              value: _vm.current_datetime,
              callback: function($$v) {
                _vm.current_datetime = $$v
              },
              expression: "current_datetime"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("AtlasTable", {
        key: _vm.current_data.dir,
        attrs: {
          id: _vm.current_data.dir,
          upper_left_corner: "預報時間",
          data_source: _vm.current_data_text,
          titles: _vm.titles,
          sidebars: _vm.current_data.kind,
          images: _vm.images
        },
        on: {
          "open-image-dialog": function(image) {
            return _vm.$emit("open-image-dialog", image)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }